import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVendorBankAccount } from "src/models/Prices/Bank.models";

interface BankAccountState {
  vendorBankAccounts: IVendorBankAccount[];
  vendorBankAccountToEdit: IVendorBankAccount | null;
}

const initialState: BankAccountState = {
  vendorBankAccounts: [],
  vendorBankAccountToEdit: null,
};

const VendorBankAccountSlice = createSlice({
  name: "VendorBankAccount",
  initialState,
  reducers: {
    setVendorBankAccountList: (state, action: PayloadAction<IVendorBankAccount[]>) => {
      state.vendorBankAccounts = action.payload;
    },
    setVendorBankAccountToEdit: (state, action: PayloadAction<IVendorBankAccount | null>) => {
      state.vendorBankAccountToEdit = action.payload;
    },
    concatListVendorBankAccount: (state: BankAccountState, action: PayloadAction<IVendorBankAccount[]>) => {
      state.vendorBankAccounts = [...state.vendorBankAccounts.concat(action.payload)];
    },
    addVendorBankAccount: (state, action: PayloadAction<IVendorBankAccount>) => {
      state.vendorBankAccounts.push(action.payload);
    },
    updateVendorBankAccount: (state, action: PayloadAction<IVendorBankAccount>) => {
      let itemIndex = state.vendorBankAccounts.findIndex(
        item => item.vendorBankAccountId === action.payload.vendorBankAccountId
      );
      if (itemIndex !== -1) state.vendorBankAccounts[itemIndex] = action.payload;
    },
    deleteVendorBankAccount: (state, action: PayloadAction<number>) => {
      const newArray = state.vendorBankAccounts.filter(
        item => item.vendorBankAccountId !== action.payload
      );
      state.vendorBankAccounts = newArray;
    },
  },
});

export const {
  setVendorBankAccountList,
  concatListVendorBankAccount,
  setVendorBankAccountToEdit,
  addVendorBankAccount,
  updateVendorBankAccount,
  deleteVendorBankAccount,
} = VendorBankAccountSlice.actions;

export default VendorBankAccountSlice.reducer;
